import React, { useContext, useEffect, useState } from "react";
import { Modal as CustomModal, Row } from "react-bootstrap";
import ComponentContext from "../Context";
import Statics from "../Statics";
import Loading from "../Containers/Loading";

const Modal = props => {
  const { className = "", children } = props;
  const context = useContext(ComponentContext);
  const [show, set_show] = useState(false);
  const [content, set_content] = useState(context.modal.content);
  const [loading, set_loading] = useState(Statics.NOT_LOADED);

  const contentChanged = () => {
    set_loading(Statics.LOADING);
    set_content(context.modal.content);
    set_loading(Statics.LOADED);
  };
  const handleClose = () => {
    context.modal.content = null;
    set_content(context.modal.content);
    set_loading(Statics.NOT_LOADED);
    set_show(false);
  };
  const handleShow = (content = "") => {
    set_show(true);
    set_content(content);
  };

  context.modal.show = handleShow;
  context.modal.hide = handleClose;
  context.modal.contentChanged = contentChanged;

  useEffect(() => {
    set_content(context.modal.content);
    if (context.modal.content) set_loading(Statics.LOADED);
  }, [context.modal.content]);

  if (!show) return "";
  return (
    <CustomModal
      show={show}
      style={{ zIndex: 9999 }}
      onHide={handleClose}
      className={className}>
      <CustomModal.Header closeButton></CustomModal.Header>
      <CustomModal.Body>
        {children ? (
          children
        ) : (
          <>
            {loading === Statics.LOADED ? content : ""}
            {loading === Statics.NOT_LOADED ? (
              <Row
                className="justify-content-center"
                style={{ padding: "5rem 0" }}>
                  <Loading />
              </Row>
            ) : (
              ""
            )}
          </>
        )}
      </CustomModal.Body>
    </CustomModal>
  );
};

export default Modal;
